export const PuzzleTypes = {
  NumberGame: 1,
  WordGame: 2,
  LimitedWordGame: 3,
  GridGame: 4,
  GridSelectGame: 5,
  MultipleChoiceGame: 6
};
